<template>
    <page-main>
        <div class="container">
            <div class="page-border">
                <query v-model="query" syear semester date ssystem college department sclass keyword="">
                </query>
                <btn-group :load="reload" :insert="insert" :del="del" :deleteItems="deleteItem.length" :input="input" :file="file">
                    <b-button variant="warning" @click="classDownload()">班級資訊下載</b-button>
                </btn-group>
            </div>
            <div class="page-border">
                <table class="table">
                    <thead>
                        <tr>
                            <th style="width:30px;"></th>
                            <th>學年度-學期</th>
                            <th>班級</th>
                            <th>日期</th>
                            <th>分數</th>
                        </tr>
                    </thead>
                    <tr v-for="item in tableData.value" :key="item.CleanID">
                        <td data-th="選擇"><input type="checkbox" v-model="deleteItem" :value="item.CleanID" /></td>
                        <td data-th="學年度-學期">{{item.SYear}}-{{item.Semester|semester}}</td>
                        <td data-th="班級">{{item.ClassName}}</td>
                        <td data-th="日期">{{item.Date|date('yyyy-mm-dd')}}</td>
                        <td data-th="分數"><b-button size="sm" variant="link" @click="edit(item.CleanID)">{{item.Score|score}}</b-button></td>
                    </tr>
                </table>
                <pagination v-model="pager" :rows="tableData.count" :rowperpage="10" @paging="load"></pagination>
            </div>
        </div>
        <Detail id="info" :modalkey="modalkey" @reload="reload" @edit="edit"></Detail>
        <inputmodal id="input" sample="/template/clean.xlsx" url="/api/clean/excel" @ok="reload"></inputmodal>
    </page-main>
</template>

<script>
    import Detail from './cleanDetail.vue';
    import { master } from '@/views';
    export default master({
        name: 'clean',
        api: '/api/clean/',
        components: { Detail },
        filters: {
            score: function (value) { return value || "不列評" }
        },
        methods: {
            file: function () {
                const $a = document.createElement("a");
                $a.href = this.$apiurl + "/api/clean/output?" + new URLSearchParams(this.query).toString();
                $a.click();
            },
            classDownload: function () {
                const $a = document.createElement("a");
                $a.href = this.$apiurl + "/api/clean/ClassOutput";
                $a.click();
            },
        }
    });
</script>

<style>
</style>